export enum ECountry {
  RU = 'RU',
  KZ = 'KZ',
  EN = 'EN'
}
export interface IMultiLang {
  [ECountry.RU]: string
  [ECountry.EN]: string
  [ECountry.KZ]: string
}

export interface TButton {
  _id: string
  title: IMultiLang
  active: boolean
}

export interface TUser {
  _id: string
  nickname?: string
  birthdate?: string
  name?: string
  phone: string
  street?: string
  house?: string
  flat?: string
  city?: TCity
  smsCode?: string
  timeSendCode?: string
  porch?: string
  floor?: string
  email?: string
}

export interface TDeliveryDetail {
  coordinates?: {
    longitude: number
    latitude: number
  }
  country?: string
  city?: string
  street?: string
  house?: string
  flat?: string
  porch?: string
  floor?: string
}
export interface TOrder {
  _id: string
  incomingOrderId: number
  orderStatusId?: TOrderStatus | string
  check: boolean
  numberTable?: string
  spotId?: string
  hide?: boolean
  orderPrice: number
  isPaid: boolean
  datetime?: string
  comment: string
  place?: number
  delivery_detail?: TDeliveryDetail
  orderType_id: TOrderType | string
  deliveryPrice?: number
  payment_id: TPayment | string
  user_id: TUser | string
  userPhone: string
  userCode?: string
  rest_id: TRest | string
  email: string
  orderList: TCartInitialState
  customInputs: TCustomInputsOrder[]
  paymentLink?: string // этот параметр приходит только в ответ для переадресации для платжеа с альфа банка
  confirmationToken?: string // токен для юкасса если используется этот тип платежа
}

export interface TCustomInputsOrder {
  name: string
  value: string
}
export interface TCartInitialState {
  dishes: TDishInCart[]
}
export interface TDishInCart {
  dish: TDish
  quantity: number
  id: string
}
export interface TOrderType {
  _id: string
  title: IMultiLang
  active: boolean
  isDelivery: boolean
  isYandexDelivery: boolean
}

export interface TOrderStatus {
  _id: string
  title: IMultiLang
  active: boolean
}

export interface TCity {
  _id?: string
  title: string
  deliveryPrice: number
  minSummOrder: number
  deliveryFree: boolean
  streets: TStreet[]
}
export interface TStreet {
  _id?: string
  name: string
  idFromIiko: string
  active: boolean
}

export interface TColor {
  _id?: string
  mainTextColor: string
  mainColor: string
  buttonTextColor: string
  buttonColor: string
  loght: string
  textLight: string
  stroke: string
  orderMadeBlock: string
  backgroundColor: string
  popupBackup: string
  popupInputColor: string
  popupBorder: string
  useLoaderImage: string | null
  useBackgroundImg: string | null
  viewGrid: boolean
  leftMenuBgColor: string
  borderInputColor: string
  borderButtonColor: string
  backgroundCarousel: string
  borderDish: string
  dishWeightColor: string
  bottomDishColor: string
  textLanguage: string
  borderCarousel: string
  backgroundButtonCarousel: string
  backgroundLoader: string
  buttonActiveCarousel: string
  colorIcon: string
  colorPrice: string
  buttonActiveTextColor: string
  textColorButtonCorousel: string
  colorModificator: string
  colorDescriptionInModal: string
  titleRestColor: string
  buttonColorCart: string
  activeButtonColorCart: string
  categoryTitleColor: string
  colorTextSale: string
  isOrderDetailBorderLineDotted: boolean
  isShowMenuInfoDishDetail: boolean
  infoBackdropBackgroundColor?: string
  infoBackdropTextColor?: string
  colorTextAboutUs: string
}

export interface TTerm {
  _id?: string
  juryAddress: string
  physicalAddress: string
  emailAddress: string
  phoneNumber: string
  shortName: string
  webSite: string
  bankDetails: string
  juryName: string
  INN: string
  OGRN: string
  addr_index: string
  correspondentAccount: string
  accountCalculation: string
  Bik: string
}

export enum ETariff {
  Trial = 'Trial',
  Basic = 'Basic',
  Extend = 'Extend',
  Pro = 'Pro',
  Vip = 'Vip'
}

export interface TPayment {
  _id: string
  title: IMultiLang
  active: boolean
  paymentPublicID: string
  onlineNamePayment?: string
}

export interface TRest {
  rest_id: string | null
  numberTable: string | null
  _id: string
  titleRest: string
  countTable: number
  currentCurrency: string
  titleTable: string
  enableDishesQr: boolean
  tariff: ETariff
  adminCode: string
  waiterCode: string
  telegramBotName: string
  yandexMetrika: string
  isIntegrationWithIiko: boolean
  NameIiko: string
  NameRestaurant: string
  payments_ids: TPayment[]
  enableTips: boolean
  tipsLayoutID: string
  enableBooking: boolean
  languages: string[]
  openTime: string
  closeTime: string
  logoPath: string
  workPhone: string
  workAddress: string
  buttons_ids: TButton[] | []
  orderType_ids: TOrderType[]
  orderStatus_ids: TOrderStatus[]
  colorsSchema_id: TColor
  pathRest: string
  city_ids: TCity[]
  terms_ids?: TTerm
  enableSms: boolean
  defaultOrderStatus_id: string
  enableDateDelivery: boolean
  country: ECountry
  incomingOrderId?: number
  customInput_ids?: TCustomInput[]
  isAdult: boolean
  isItRestaurantChain: boolean
  social_ids: ISocialId[]
  email: string
  isReturningGoods: boolean
  isWorkingHours: boolean
  textReturningGoods: string
  textWorkingHours: string
  location_detail: {
    country: ECountry
    city: string
    street: string
    building: string
    porch: string
    sfloor: string
    coordinates: {
      latitude: number
      longitude: number
    }
  }
  defaultDeliveryOrderPrice: number
}
export interface ISocialId {
  _id: string
  active: boolean
  image: string
  link: string
  title: string
}
export interface TSale {
  _id?: string
  action: boolean
  title: string
  description: string
  image: string
  dateStartSales: string
  dateFinishSales: string
  rest_id: TRest | string
  showInAutoPopup: boolean
}
export interface TCategoryModifier {
  _id: string
  active: boolean
  title: IMultiLang
  sort: number
  categoryModifiers_id: TCategoryModifier | string
  modifiers_ids: TModifier[]
  idFromIiko: string
  isGroupModifierCategoryRadio: boolean
  isGroupModifierRequired: boolean
}
export interface TModifier {
  _id: string
  title: IMultiLang
  active: boolean
  image: string
  sort: number
  price: number
  categoryModifier: TCategoryModifier | string
  unit: string
  weight: number
  description: string
  idFromIiko: string
}

export enum EDayOfWeek {
  Monday = 'Monday',
  Tuesday = 'Tuesday',
  Wednesday = 'Wednesday',
  Thursday = 'Thursday',
  Friday = 'Friday',
  Saturday = 'Saturday',
  Sunday = 'Sunday'
}

export interface ITimesOfValues {
  start?: string
  end?: string
}

export interface IValuesOfDisplayInterval {
  day: EDayOfWeek
  times: Array<ITimesOfValues | undefined>
}

export interface TCategory {
  _id: string
  active: boolean
  category_id: TCategory | string | null
  idFromIiko: string
  noImagesCategory: boolean
  sort: number
  title: IMultiLang
  typeMenu_id: string
  rest_id: TRest | string
  isDisplayIntervalCategory: boolean
  displayInterval: Array<IValuesOfDisplayInterval | undefined>
}

export interface TDish {
  _id: string
  title: any
  active: boolean
  image: string
  imageQr: string
  sort: number
  price: number
  discount: number
  category_id: TCategory | string
  unit: string
  weight: number
  description: IMultiLang
  descriptionId: string
  colorQr: string
  fontFamilyQr: string
  idFromIiko: string
  modifiers_ids: TModifier[]
  groupModifiers_ids: TCategoryModifier[]
  rest_id: TRest | string
  crossSaleDish_ids: TSale[] | string[]
}
export interface TSubCategories {
  subcategories: TSubCategories[] | []
  category: TCategory
  dishes: TDish[] | []
}
export interface TCustomInput {
  _id: string
  name: string
  placeholder: IMultiLang
  label: IMultiLang
  required: boolean
}
export interface TAdmin {
  _id?: string
  nickname: string
  password: string
  rest_id?: TRest | string
}
